let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8te3e")).then(() => parcelRequire('d5yYM'));